import React from 'react';

import { createClassName } from 'utils/createClassName';

import './clickControlStyles.scss';

type Props = {
  disabled?: boolean;
  submit?: boolean;
  onClick?(): void;
};

export const ClickControlComponent: React.FC<Props> = (props) => {
  const { children, disabled, submit, onClick } = props;

  const createClickControlClassName = createClassName('clickControl');

  const buttonClassName = createClickControlClassName('button');

  return (
    <button
      type={submit ? 'submit' : 'button'}
      disabled={disabled}
      className={buttonClassName}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
